import React, { useContext, useEffect } from "react";
import { DataContext } from "../../Context/Context";
import { makeStyles } from "@material-ui/core/styles";
import { Button } from "@material-ui/core";
import Modal from "@material-ui/core/Modal";
import TextField from "@material-ui/core/TextField";
import FormControl from "@material-ui/core/FormControl";
import NativeSelect from "@material-ui/core/NativeSelect";
import { FormGroup } from "@material-ui/core";
import { IconPickerItem } from "react-fa-icon-picker";
import Autocomplete from "@material-ui/lab/Autocomplete";
import DateFnsUtils from "@date-io/date-fns";
import { DatePicker, MuiPickersUtilsProvider } from "@material-ui/pickers";

const useStyles = makeStyles((theme) => ({
  paper: {
    position: "absolute",
    left: "50%",
    top: "50%",
    transform: "translate(-50%, -50%)",
    width: 380,
    height: 500,
    backgroundColor: theme.palette.background.paper,
    border: "1px solid lightgrey",
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
  },
  select: {
    padding: "18.5px 14px",
    border: "1px solid lightgrey",
    borderRadius: "4px",
    marginLeft: 0,
    marginBottom: 30,
    width: "100%",
    color: "#a2a2a2",
    height: "1.1876em",
  },
  option: {
    color: "grey",
  },
  amount: {
    marginBottom: 30,
    marginTop: 30,
  },
  datePicker: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: "18.5px 14px",
    border: "1px solid lightgrey",
    borderRadius: "4px",
    marginLeft: 0,
    marginBottom: 30,
    width: "100%",
    height: "1.1876em",
    color: "grey",
  },
  icon: {
    marginTop: 20,
  },
  modalAddUpdateBtn: {
    color: "white",
    backgroundColor: "#6200ee",
    fontWeight: "bold",
    "&:hover": {
      backgroundColor: "#6200ee",
    },
  },
  modalCancelBtn: {
    color: "#6200ee",
    textTransform: "uppercase",
    fontWeight: "bold",
  },
  modalBtns: {
    display: "flex",
    justifyContent: "space-between",
    marginTop: 50,
  },
}));

export default function ModalEntries() {
  const classes = useStyles();

  const {
    setOpenFabModal,
    wizardCategories,
    entries,
    setEntries,
    openEntryModal,
    setOpenEntryModal,
    editingEntry,
    addNewItem,
    setAddNewItem,
  } = useContext(DataContext);

  const handleClose = () => {
    setOpenEntryModal(false);
    setOpenFabModal(false);
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    if (editingEntry !== false) {
      let tempAddEntry = entries;
      tempAddEntry[editingEntry] = addNewItem;

      localStorage.setItem("entries", JSON.stringify(tempAddEntry));
      setEntries(tempAddEntry);
    } else {
      localStorage.setItem("entries", JSON.stringify([...entries, addNewItem]));
      setEntries([...entries, addNewItem]);

      setAddNewItem({
        id: new Date().valueOf(),
        type: "Income",
        category: "",
        amount: "",
        date: new Date(),
        desc: "",
      });
    }

    setOpenEntryModal(false);
    setOpenFabModal(false);
  };

  const bodyAddNew = (
    <>
      <form className={classes.paper} onSubmit={(e) => handleSubmit(e)}>
        <p>{`${editingEntry !== false ? "Update" : "Add new"} entry`}</p>
        <FormGroup>
          <FormControl className={classes.formControl}>
            <NativeSelect
              value={addNewItem.type || "Income"}
              onChange={(e) =>
                setAddNewItem({ ...addNewItem, type: e.target.value })
              }
              className={classes.select}
            >
              <option className={classes.option} value={"Income"}>
                Income
              </option>
              <option className={classes.option} value={"Expense"}>
                Expense
              </option>
            </NativeSelect>
          </FormControl>
          <FormControl>
            <Autocomplete
              id="combo-box-demo"
              value={addNewItem.category || ""}
              onChange={(event, values) =>
                setAddNewItem({ ...addNewItem, category: values })
              }
              size="small"
              options={wizardCategories.filter(
                (c) => c.type === addNewItem.type
              )}
              getOptionLabel={(option) => option.name || ""}
              renderInput={(params) => (
                <TextField
                  {...params}
                  required
                  label="Category"
                  variant="outlined"
                />
              )}
            />
          </FormControl>
          <FormControl>
            <TextField
              className={classes.amount}
              type="number"
              id="outlined-basic"
              variant="outlined"
              placeholder="Amount"
              size="small"
              required
              value={addNewItem.amount || ""}
              onChange={(e) =>
                setAddNewItem({ ...addNewItem, amount: e.target.value })
              }
            />
          </FormControl>
          <FormControl>
            <MuiPickersUtilsProvider utils={DateFnsUtils}>
              <div className={classes.datePicker}>
                <DatePicker
                  value={addNewItem.date || new Date()}
                  onChange={(e) => setAddNewItem({ ...addNewItem, date: e })}
                  format="dd.MM.yyyy"
                />
                <IconPickerItem
                  className={classes.icon}
                  icon="FaCalendar"
                  color="inherit"
                />
              </div>
            </MuiPickersUtilsProvider>
          </FormControl>
          <FormControl>
            <TextField
              className={classes.desc}
              type="text"
              id="outlined-basic"
              variant="outlined"
              placeholder="Description (optional)"
              size="small"
              value={addNewItem.desc || ""}
              onChange={(e) =>
                setAddNewItem({ ...addNewItem, desc: e.target.value })
              }
            />
          </FormControl>
        </FormGroup>
        <div className={classes.modalBtns}>
          <Button onClick={handleClose} className={classes.modalCancelBtn}>
            Cancel
          </Button>
          <Button type={"submit"} className={classes.modalAddUpdateBtn}>
            {`${editingEntry !== false ? "Update" : "Add"}`}
          </Button>
        </div>
      </form>
    </>
  );
  return (
    <div>
      <Modal
        open={openEntryModal}
        aria-labelledby="simple-modal-title"
        aria-describedby="simple-modal-description"
        className={classes.modal}
      >
        {bodyAddNew}
      </Modal>
    </div>
  );
}
